import React from 'react';
import { Box, BoxProps, Grid, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';

const useStyles = makeStyles((theme: Theme) => ({
  box: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1),
    margin: 'auto',
    overflow: 'hidden',
  },
}));

type Props = React.PropsWithChildren<{
  className?: string;
  /**
   * Instead of using the Grid container with flex column,
   * a simple Box (div) component is used. Use in case text ellipsis are needed,
   * since there's an issue with ellipsis and flex-direction: column.
   */
  disableGrid?: boolean;
  px?: BoxProps['px'];
  py?: BoxProps['py'];
  width?: BoxProps['width'];
}>;

const RoomSidebar: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = useStyles();

  const { children, className, disableGrid = false, px, py, width } = props;

  let content = children;
  if (!disableGrid) {
    content = (
      <Grid className={className} container direction="column" spacing={4}>
        {children}
      </Grid>
    );
  }

  return (
    <Box
      className={classNames(classes.box, className)}
      px={px ?? 4}
      py={py ?? 3}
      width={width ?? { md: '95%', lg: '90%' }}
    >
      {content}
    </Box>
  );
};

export default RoomSidebar;
